import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './confirmation.css';
import '../footer/about.css';

const ConfirmationPage = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    navigate('/emailconnect');
  };

  return (
    <div className='general-container-footer-info-ab'>
      <div className='info-footer-container-ab'>
        <section className='section-about-1'>
          <div>
            <h3 className='align-about-ab'>
              <span className='acasa-about-footer'>Acasa</span>
              <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
              <span className='color-despre'>Confirmare cont</span>
            </h3>
          </div>
        </section>

        <div className='confirmation-wrapper'>
          <div className="confirmation-page">
            <div className="success-icon-container">
              <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
            </div>
            <h2>Cont confirmat cu succes!</h2>
            <p className="confirmation-message">
              Felicitări! Adresa ta de email a fost verificată cu succes.
            </p>
            <p className="confirmation-submessage">
              Acum te poți autentifica și începe călătoria de învățare în lumea contabilității.
            </p>
            <button onClick={goToLogin} className="btn-confirmation-primary">
              Autentifică-te acum
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
